import type React from "react";
import { useState } from "react";
import Button from "../Buttons/Button";
import { MdOutlineFileDownload } from "react-icons/md";
import type { IconType } from "react-icons";
import { sendAnalyticsEvent } from "../../FirebaseConfig";

interface Props {
    pdfUrl: string;
    fileName: string;
    label?: string;
    className?: string;
    icon?: IconType | null;
    iconSize?: number;
    module: string;
    source: string;
    disabledHover?: boolean;
}

const DownloadPDFButton: React.FC<Props> = ({
    pdfUrl,
    fileName,
    label = "Descargar",
    className,
    icon = MdOutlineFileDownload,
    iconSize = 16,
    module,
    source,
    disabledHover = false,
}) => {
    const [isLoading, setIsLoading] = useState(false);

    const handleDownload = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(pdfUrl);
            const blob = await response.blob();

            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);

            sendAnalyticsEvent("downloaded_report", {
                report_title: fileName.trim(),
                file_type: "pdf",
                source: source,
                module: module,
            });

            document.body.appendChild(link);
            link.click();

            URL.revokeObjectURL(url);
            document.body.removeChild(link);
        } catch (error) {
            console.error("Error al descargar el archivo PDF:", error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Button
            onClick={handleDownload}
            label={isLoading ? "Descargando..." : label}
            as="link"
            icon={icon ? icon : undefined}
            showIconLeft={true}
            showIconRight={false}
            className={className}
            disabled={isLoading}
            iconSize={iconSize}
            disableHover={disabledHover}
        />
    );
};

export default DownloadPDFButton;